function formatMoney(t) {
  let e = document.body.dataset.money_format;
  const money_format = "${{amount}}";
  function n(t, e) {
    return void 0 === t ? e : t;
  }
  function o(t, e, o, i) {
    if (
      ((e = n(e, 2)),
      (o = n(o, ",")),
      (i = n(i, ".")),
      isNaN(t) || null == t)
    )
      return 0;
    var r = (t = (t / 100).toFixed(e)).split(".");
    return (
      r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + o) +
      (r[1] ? i + r[1] : "")
    );
  }
  "string" == typeof t && (t = t.replace(".", ""));
  var i = "",
    r = /\{\{\s*(\w+)\s*\}\}/,
    a = e || document.body.dataset.moneyFormat || money_format;
  switch (a.match(r)[1]) {
    case "amount":
      i = o(t, 2);
      break;
    case "amount_no_decimals":
      i = o(t, 0);
      break;
    case "amount_with_comma_separator":
      i = o(t, 2, ".", ",");
      break;
    case "amount_with_space_separator":
      i = o(t, 2, " ", ",");
      break;
    case "amount_with_period_and_space_separator":
      i = o(t, 2, " ", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      i = o(t, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      i = o(t, 0, " ");
      break;
    case "amount_with_apostrophe_separator":
      i = o(t, 2, "'", ".");
  }
  return a.replace(r, i);
}